<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button
        (click)="dismiss()"
        class="ion-no-margin"
        [title]="'COMMON.LABELS.CLOSE' | translate"
        [attr.aria-label]="'COMMON.LABELS.CLOSE' | translate"
        data-cy="share-modal-close"
      >
        <svg-icon
          class="color--dark"
          key="close"
          size="xl"
        ></svg-icon>
      </ion-button>
    </ion-buttons>
    <ion-title
      class="text--md text--normal"
      role="heading"
      aria-level="1"
    >
      {{ "COMMON.LABELS.SHARE" | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<div class="inner-content">
  <div class="share">
    <!-- The code on a sheet of paper: what Drucken puts on the wall. -->
    <div class="stage">
      <figure class="card">
        <img
          *ngIf="qr; else qrPlaceholder"
          class="qr"
          [src]="qr"
          [alt]="'COMPONENTS.SHARE.QR_ALT' | translate: { title: props.title }"
          data-cy="share-qr"
        />
        <ng-template #qrPlaceholder>
          <div class="qr"></div>
        </ng-template>
        <figcaption class="card-title">{{ props.title }}</figcaption>
      </figure>
    </div>

    <div class="side">
      <div>
        <span class="label">{{ "COMPONENTS.SHARE.LINK" | translate }}</span>
        <div class="field">
          <span
            class="url"
            data-cy="share-url"
          >
            {{ displayUrl }}
          </span>
          <button
            type="button"
            class="copy-link"
            [class.is-copied]="linkCopied"
            (click)="copyLink()"
            data-cy="share-copy-link"
          >
            <span aria-live="polite">
              <ng-container *ngIf="linkCopied; else copyLabel">
                <svg-icon
                  key="check"
                  [fontSize]="18"
                  aria-hidden="true"
                ></svg-icon>
                {{ "COMPONENTS.SHARE.COPIED" | translate }}
              </ng-container>
              <ng-template #copyLabel>
                {{ "COMPONENTS.SHARE.COPY" | translate }}
              </ng-template>
            </span>
          </button>
        </div>
        <p class="help">{{ "COMPONENTS.SHARE.ACCESS_HINT" | translate }}</p>
      </div>

      <div *ngIf="!native; else nativeShare">
        <span class="label">{{ "COMPONENTS.SHARE.QR_CODE" | translate }}</span>
        <div class="tiles">
          <button
            type="button"
            class="tile"
            (click)="print()"
            data-cy="share-print"
          >
            <svg-icon
              key="printer"
              [fontSize]="22"
              aria-hidden="true"
            ></svg-icon>
            {{ "COMPONENTS.SHARE.PRINT" | translate }}
          </button>
          <button
            type="button"
            class="tile"
            (click)="download()"
            data-cy="share-download"
          >
            <svg-icon
              key="download-simple"
              [fontSize]="22"
              aria-hidden="true"
            ></svg-icon>
            {{ "COMMON.LABELS.DOWNLOAD" | translate }}
          </button>
        </div>
      </div>

      <ng-template #nativeShare>
        <ion-button
          expand="block"
          fill="outline"
          (click)="shareLink()"
          data-cy="share-native"
        >
          <svg-icon
            slot="start"
            key="share"
            [fontSize]="20"
            aria-hidden="true"
          ></svg-icon>
          {{ "COMPONENTS.SHARE.SHARE_LINK" | translate }}
        </ion-button>
      </ng-template>
    </div>
  </div>
</div>

<!-- What Drucken prints, copied into a frame of its own. -->
<div hidden>
  <div
    #poster
    class="poster"
  >
    <img
      *ngIf="logo"
      class="poster-logo"
      [src]="logo"
      alt=""
    />
    <h1 class="poster-title">{{ props.title }}</h1>
    <img
      *ngIf="qr"
      class="poster-qr"
      [src]="qr"
      alt=""
    />
    <p class="poster-hint">{{ scanHint | translate }}</p>
    <p class="poster-url">{{ displayUrl }}</p>
  </div>
</div>
